import clsx from 'clsx'
import React, {useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import Container from 'react-bootstrap/Container'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../../gori/components'
import {Button} from '../../../../../../gori/widgets'
import {COMMONS} from '../../../core/constants'

type Props = {
  show: boolean
  handleCloseValidation: () => void
  handleUseSuggested: (key?: string) => void
  dataSuggest: any
  dataOriginal: any
  fromOrTo?: 'from' | 'to'
}

const AddressValidationModal: React.FC<Props> = ({
  show,
  handleCloseValidation,
  handleUseSuggested,
  dataSuggest,
  dataOriginal,
  fromOrTo,
}) => {
  const intl = useIntl()
  const [iconShow, setIconShow] = useState(false)

  // Get actual data based on whether fromOrTo is provided
  const suggestData = fromOrTo ? dataSuggest?.[fromOrTo] : dataSuggest
  const originalData = fromOrTo ? dataOriginal?.[fromOrTo] : dataOriginal

  const checkEqual = useMemo(() => {
    return COMMONS.VALIDATE_ADDRESS.every((item) => {
      const suggestValue = suggestData?.[item]
      const originalValue = fromOrTo ? originalData?.[`${fromOrTo}_${item}`] : originalData?.[item]
      return suggestValue === originalValue
    })
  }, [originalData, suggestData, fromOrTo])

  const checkAddressValid =
    suggestData?.verifications?.delivery?.success && suggestData?.verifications?.zip4?.success

  const getOriginalValue = (field: string) => {
    return fromOrTo ? originalData?.[`${fromOrTo}_${field}`] : originalData?.[field]
  }

  return (
    <>
      <Modal
        id='gori_modal_new_order'
        tabIndex={-1}
        aria-hidden='true'
        centered
        dialogClassName='mw-800px h-auto'
        show={show}
      >
        <div className='modal-content'>
          <Modal.Header closeButton={false}>
            <Modal.Title bsPrefix={'fw-bolder fs-1'}>
              {intl.formatMessage({id: 'VERIFICATION_ADDRESS'})}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <div className='row my-4'>
                {fromOrTo && (
                  <h3 className='text-dark'>{intl.formatMessage({id: fromOrTo.toUpperCase()})}</h3>
                )}
                <div className='col-md-12 d-flex flex-fill justify-content-between'>
                  {checkAddressValid ? (
                    <>
                      <div className='col-md-5'>
                        <h5 className='text-dark'>{intl.formatMessage({id: 'SUGGESTED'})}</h5>
                        <div className='text-dark'>{suggestData?.street1}</div>
                        <div className='text-dark'>{`${suggestData?.city}, ${suggestData?.state} ${suggestData?.zip}`}</div>
                        <div className='text-dark'>{suggestData?.country}</div>
                      </div>
                      <div className='col-md-5 mx-3'>
                        <h5 className='text-dark'>{intl.formatMessage({id: 'ORIGINAL'})}</h5>
                        <div className='text-dark'>{getOriginalValue('street1')}</div>
                        <div className='text-dark'>{`${getOriginalValue(
                          'city'
                        )}, ${getOriginalValue('state')} ${getOriginalValue('zip')}`}</div>
                        <div className='text-dark'>{getOriginalValue('country')}</div>
                      </div>
                      <div className='col-md-2 d-flex flex-column justify-content-center align-items-center'>
                        {checkEqual || iconShow ? (
                          <KTSVG path='/media/gori/orders/success.svg' small={false} />
                        ) : (
                          <>
                            <div
                              className='fs-8 p-2 bg-secondary mb-3 rounded-2 text-center cursor-pointer'
                              onClick={() => {
                                setIconShow(true)
                                handleUseSuggested(fromOrTo)
                              }}
                            >
                              {intl.formatMessage({id: 'USE_SUGGESTED'})}
                            </div>
                            <div
                              className='fs-8 p-2 bg-primary text-white mb-3 rounded-2 text-center cursor-pointer'
                              onClick={() => setIconShow(true)}
                            >
                              {intl.formatMessage({id: 'KEEP_ORIGINAL'})}
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className='d-flex flex-fill justify-content-center'>
                      <h3 className={clsx('text-center text-danger')}>
                        {intl.formatMessage({
                          id: 'ADDRESS_IS_INVALID',
                        })}
                      </h3>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <div className='d-flex justify-content-end'>
              <Button
                className='btn btn-secondary'
                label={intl.formatMessage({id: 'CLOSE'})}
                event={handleCloseValidation}
              />
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  )
}

export {AddressValidationModal}
